import { COMPANY } from "./types";

import ActionHelper from "../helpers/ActionHelper";

import moment, { isMoment } from "moment";

import queryString from "query-string";

export const createCompany = (form) => {
  return ActionHelper.requestServer("POST", "/company", form);
};

export const getCompanies =
  ({ hasScheduledShiftBefore, hasScheduledShiftAfter } = {}) =>
  (dispatch) => {
    const params = {
      ...(hasScheduledShiftBefore && {
        hasScheduledShiftBefore: moment(hasScheduledShiftBefore)
          .endOf("day")
          .toISOString(),
      }),
      ...(hasScheduledShiftAfter && {
        hasScheduledShiftAfter: moment(hasScheduledShiftAfter)
          .startOf("day")
          .toISOString(),
      }),
    };

    const stringified = queryString.stringify(params);
    return ActionHelper.requestServer(
      "GET",
      `/company?${stringified}`,
      null,
      COMPANY.COMPANY_GET_COMPANIES_REQUEST,
      COMPANY.COMPANY_GET_COMPANIES_SUCCESS,
      COMPANY.COMPANY_GET_COMPANIES_FAIL,
      dispatch,
    );
  };

export const getCompany = (id) =>
  ActionHelper.requestServer("GET", "/company/" + id);

export const updateCompany = (id, form) =>
  ActionHelper.requestServer("PUT", "/company/" + id, form);

export const deleteCompany = (id) => (dispatch) => {
  return ActionHelper.requestServer(
    "DELETE",
    "/company/" + id,
    null,
    COMPANY.COMPANY_DELETE_REQUEST,
    COMPANY.COMPANY_DELETE_SUCCESS,
    COMPANY.COMPANY_DELETE_FAIL,
    dispatch,
  );
};

export const assignEmployee = (form) => (dispatch) => {
  let payload = form;

  if (moment.isMoment(payload.cardValidity)) {
    payload.cardValidity = moment(payload.cardValidity).format("YYYY-MM-DD");
  }

  return ActionHelper.requestServer(
    "POST",
    "/company/" + payload.company + "/employee",
    payload,
    COMPANY.COMPANY_ASSIGN_EMPLOYEE_REQUEST,
    COMPANY.COMPANY_ASSIGN_EMPLOYEE_SUCCESS,
    COMPANY.COMPANY_ASSIGN_EMPLOYEE_FAIL,
    dispatch,
  );
};

export const getCompanyEmployees =
  (company, params = {}) =>
  (dispatch) => {
    var query = "?";

    Object.keys(params).map((key) => (query += `${key}=${params[key]}`));

    return ActionHelper.requestServer(
      "GET",
      `/company/${company}/employee${query}`,
      null,
      COMPANY.COMPANY_GET_COMPANY_EMPLOYEES_REQUEST,
      COMPANY.COMPANY_GET_COMPANY_EMPLOYEES_SUCCESS,
      COMPANY.COMPANY_GET_COMPANY_EMPLOYEES_FAIL,
      dispatch,
    );
  };

export const getCompanyEmployee = (company, employee) => (dispatch) => {
  return ActionHelper.requestServer(
    "GET",
    "/company/" + company + "/employee/" + employee,
    null,
    COMPANY.COMPANY_GET_COMPANY_EMPLOYEE_REQUEST,
    COMPANY.COMPANY_GET_COMPANY_EMPLOYEE_SUCCESS,
    COMPANY.COMPANY_GET_COMPANY_EMPLOYEE_FAIL,
    dispatch,
  );
};

export const updateCompanyEmployee =
  (company, employee, form) => (dispatch) => {
    let payload = form;

    if (moment.isMoment(payload.cardValidity)) {
      payload.cardValidity = moment(payload.cardValidity).format("YYYY-MM-DD");
    }

    return ActionHelper.requestServer(
      "PUT",
      "/company/" + company + "/employee/" + employee,
      payload,
      COMPANY.COMPANY_UPDATE_COMPANY_EMPLOYEE_REQUEST,
      COMPANY.COMPANY_UPDATE_COMPANY_EMPLOYEE_SUCCESS,
      COMPANY.COMPANY_UPDATE_COMPANY_EMPLOYEE_FAIL,
      dispatch,
    );
  };

export const deleteCompanyEmployee = (company, employee) => (dispatch) => {
  return ActionHelper.requestServer(
    "DELETE",
    "/company/" + company + "/employee/" + employee,
    null,
    COMPANY.COMPANY_DELETE_COMPANY_EMPLOYEE_REQUEST,
    COMPANY.COMPANY_DELETE_COMPANY_EMPLOYEE_SUCCESS,
    COMPANY.COMPANY_DELETE_COMPANY_EMPLOYEE_FAIL,
    dispatch,
  );
};

export const getHourRegistrationOfCompany = (
  companyEmail,
  beginDate,
  endDate,
) => {
  let params = [];

  if (isMoment(beginDate)) {
    beginDate.startOf("day");

    params.push(`beginDate=${beginDate.toISOString()}`);
  }

  if (isMoment(endDate)) {
    endDate.endOf("day");

    params.push(`endDate=${endDate.toISOString()}`);
  }

  return ActionHelper.requestServer(
    "GET",
    `/company/${companyEmail}/hour_registration?${params.join("&")}`,
  );
};

export const getHourRegistrationForInvoicesOfCompany = (
  companyEmail,
  beginDate,
  endDate,
) => {
  let params = [];

  if (isMoment(beginDate)) {
    beginDate.startOf("day");

    params.push(`beginDate=${beginDate.toISOString()}`);
  }

  if (isMoment(endDate)) {
    endDate.endOf("day");

    params.push(`endDate=${endDate.toISOString()}`);
  }

  return ActionHelper.requestServer(
    "GET",
    `/company/${companyEmail}/hour_registration_for_invoices?${params.join(
      "&",
    )}`,
    null,
  );
};

export const getSchedule =
  (companyEmail, beginDatetime, endDatetime, allEmployees = true) =>
  (dispatch) => {
    let params = [`allEmployees=${allEmployees}`];

    if (moment.isMoment(beginDatetime)) {
      beginDatetime.startOf("day");

      params.push(`beginDatetime=${beginDatetime.toISOString()}`);
    }

    if (moment.isMoment(endDatetime)) {
      endDatetime.endOf("day");

      params.push(`endDatetime=${endDatetime.toISOString()}`);
    }

    return ActionHelper.requestServer(
      "GET",
      `/company/${companyEmail}/schedule?${params.join("&")}`,
      null,
      COMPANY.COMPANY_GET_SCHEDULE_REQUEST,
      COMPANY.COMPANY_GET_SCHEDULE_SUCCESS,
      COMPANY.COMPANY_GET_SCHEDULE_FAIL,
      dispatch,
    );
  };

export const getFilesOfCompany = (companyEmail) =>
  ActionHelper.requestServer("GET", `/company/${companyEmail}/file`);



// WEBPACK FOOTER //
// ./src/actions/companyActions.js